import { useState } from 'react'

export default function InputPanel({ sendMessage }) {

    const [valueMessage, setValueMessage] = useState('')
    const [valueUpload, setValueUpload] = useState('')

    const btn_send_message = () => {

        let _val = valueMessage.trim()

        setTimeout(() => setValueMessage(''), 0)

        sendMessage(_val)

    }

    const onKeyPress = (e) => {

        if (e.key === 'Enter') btn_send_message()

    }

    const changeHandlerUpload = (e) => {
        let _key = e.target.files[0].type.split('/')[0]
        let obj = { [_key]: URL.createObjectURL(e.target.files[0]) }
        setValueUpload('')
        sendMessage(obj, e.target.files[0])

    }

    return (

        <div className="input_panel">
            <textarea name="" id="" cols="30" onKeyDown={onKeyPress} rows="10" onChange={(e) => setValueMessage(e.target.value)} value={valueMessage}></textarea>
            <div className="send_message_btn" onClick={btn_send_message}></div>
            <label htmlFor="input_upload" className='upload_message_btn'></label>
            <input type="file" name="" id="input_upload" value={valueUpload} onChange={changeHandlerUpload} />
        </div>

    )

}